var _a;
import once from 'lodash/once';
import React from 'react';
var Consent = {
    Stamp: 'stamp',
    Necessary: 'necessary',
    Preferences: 'preferences',
    Statistics: 'statistics',
    Marketing: 'marketing',
};
/**
 * These are based on Cookiebot generated object
 * https://www.cookiebot.com/en/developer/
 * {stamp: 'Yt5...==', necessary: true, preferences: false, statistics: false, marketing: false}
 */
export var DEFAULT_COOKIE_CONSENT = (_a = {},
    _a[Consent.Stamp] = '',
    _a[Consent.Necessary] = true,
    _a[Consent.Preferences] = false,
    _a[Consent.Statistics] = false,
    _a[Consent.Marketing] = false,
    _a);
var setEventListeners = once(function (handleCookiebotAccept, handleCookiebotDecline) {
    window.addEventListener('CookiebotOnAccept', handleCookiebotAccept, false);
    window.addEventListener('CookiebotOnDecline', handleCookiebotDecline, false);
});
var removeEventListeners = once(function (handleCookiebotAccept, handleCookiebotDecline) {
    window.removeEventListener('CookiebotOnAccept', handleCookiebotAccept, false);
    window.removeEventListener('CookiebotOnDecline', handleCookiebotDecline, false);
});
export var useCookiebotConsent = function () {
    var _a = React.useState(DEFAULT_COOKIE_CONSENT), consent = _a[0], setConsent = _a[1];
    var _b = React.useState([]), allowedConsent = _b[0], setAllowedConsent = _b[1];
    var _c = React.useState([]), deniedConsent = _c[0], setDeniedConsent = _c[1];
    function updateConsent() {
        var _a = window.Cookiebot.consent, stamp = _a.stamp, necessary = _a.necessary, preferences = _a.preferences, statistics = _a.statistics, marketing = _a.marketing;
        var newConsent = { stamp: stamp, necessary: necessary, preferences: preferences, statistics: statistics, marketing: marketing };
        setConsent(newConsent);
        var _b = Object.entries(newConsent)
            .filter(function (_a) {
            var key = _a[0];
            return key !== 'stamp';
        })
            .reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            acc[value ? 0 : 1].push(key);
            return acc;
        }, [[], []]), newAllowedConsent = _b[0], newDeniedConsent = _b[1];
        setAllowedConsent(newAllowedConsent);
        setDeniedConsent(newDeniedConsent);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
    React.useEffect(function () {
        setEventListeners(updateConsent, updateConsent);
        return function () {
            removeEventListeners(updateConsent, updateConsent);
        };
    }, []);
    return { consent: consent, allowedConsent: allowedConsent, deniedConsent: deniedConsent };
};
